import { useEffect, useState } from 'react';

/** Live-ticking seconds-remaining until `closeMs`, recomputed from the clock every second. */
export function useCountdown(closeMs: number | null): number | null {
  const [secondsRemaining, setSecondsRemaining] = useState<number | null>(() =>
    closeMs === null ? null : Math.max(0, Math.round((closeMs - Date.now()) / 1000)),
  );

  useEffect(() => {
    if (closeMs === null) {
      setSecondsRemaining(null);
      return;
    }

    const tick = () =>
      setSecondsRemaining(Math.max(0, Math.round((closeMs - Date.now()) / 1000)));
    tick();
    const interval = window.setInterval(tick, 1000);
    return () => window.clearInterval(interval);
  }, [closeMs]);

  return secondsRemaining;
}
